module.exports = __webpack_public_path__ + "static/media/gavleborg.8b78eca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/gavleborg.png
// module id = 232
// module chunks = 0